import { useLocalSearchParams } from 'expo-router';
import { ProfileScreen } from '@/components/domain/profile/ProfileScreen';

export default function EventProfile() {
  const { eventCode } = useLocalSearchParams<{ eventCode: string }>();

  return <ProfileScreen userName={eventCode} isEvent />;
}
